import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { AnalyticsService } from '@core/services';
import { CustomLoaders, LoadingService } from '@core/services/loading/loading.service';
import { Observable } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { MbTabsModule } from '@am/moebius';

@Component({
    selector: 'detail-menu',
    templateUrl: './detail-menu.component.html',
    styleUrls: ['./detail-menu.component.scss'],
    standalone: true,
    imports: [
        MbTabsModule,
        NgIf,
        AsyncPipe,
    ],
})
export class DetailMenuComponent implements OnInit, OnChanges {
  @Input()
  disableRooms: boolean;
  @Input()
  disableReviews: boolean;
  @Input()
  disableRelated: boolean;
  @Input()
  actualContainer: string;
  @Input()
  scrollMenu: boolean;
  @Input()
  error: boolean;
  @Output()
  tabClicked: EventEmitter<any> = new EventEmitter<any>();

  public loading$: Observable<boolean>;

  public menu: HTMLElement;
  public innerMenu: HTMLElement;

  constructor(
    private analyticsService: AnalyticsService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit() {
    this.onScroll(false);
    this.loading$ = this.loadingService.getCustomLoader(CustomLoaders.HOTEL_AVAILABILITY);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.actualContainer) {
      this.selectTab(
        changes.actualContainer.previousValue,
        changes.actualContainer.currentValue,
      );
    }
    if (changes.scrollMenu) {
      this.onScroll(changes.scrollMenu.currentValue);
    }
  }

  private onScroll(scroll) {
    this.menu = document.querySelector('#menu-container-am');
    this.innerMenu = document.querySelector('#inner-menu');
    if (scroll) {
      this.innerMenu.classList.remove('inner-menu');
      this.menu.classList.add('on-scroll');
      this.menu.classList.add('anim-scroll');
    } else {
      this.menu.classList.remove('on-scroll');
      this.innerMenu.classList.add('inner-menu');
      this.menu.classList.remove('anim-scroll');
    }
  }

  private selectTab(prevSelected, selected) {
    const prevSelectedTab = document.querySelector(`#${prevSelected}`);
    const selectedTab = document.querySelector(`#${selected}`);
    if (prevSelectedTab) {
      prevSelectedTab.classList.remove('mb-tabs__tab--active');
    }
    if (selectedTab) {
      selectedTab.classList.add('mb-tabs__tab--active');
    }
  }

  public handleClickTab(data: any) {
    const id = typeof data.tab.id === 'function' ? data.tab.id() : data.tab.id;
    this.tabClicked.emit(id);
    this.trackMenuClick(id);
  }

  private trackMenuClick(data: string) {
    this.analyticsService.trackEvent({
      section: 'Detail',
      action: `Menu ${data} tab`,
      label: 'Click',
    });
  }
}
